import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

const MoveBtn = ({ title, route, direction, target }) => (

  <Link to={route} target={target}>
    <button type='button' className={direction === 'back' ? 'btn btn-light w-100' : 'btn btn-danger w-100'}>
      {direction === 'back' ? <i className='fa fa-long-arrow-left' /> : ''}
      <span className={direction === 'back' ? 'float-right' : 'float-left'}>{title}</span>
      {direction === 'forward' ? <i className='fa fa-long-arrow-right' /> : ''}
    </button>
  </Link>
)

MoveBtn.propTypes = {
  title: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  target: PropTypes.string
}

export default MoveBtn



// WEBPACK FOOTER //
// ./src/molecules/components/MoveBtn.js